import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import AppScreens from "@/components/landing/AppScreens";
import { VideoReels } from "@/components/landing/VideoSections";
import StyleCheck from "@/components/landing/StyleCheck";
import { ColorTestTeaser } from "@/pages/ColorTypeTest";
import Features from "@/components/landing/Features";
import Social from "@/components/landing/Social";
import { SocialProofBar } from "@/components/landing/SocialProofBar";
import MiraSeal from "@/components/landing/MiraSeal";
import Testimonials from "@/components/landing/Testimonials";
import B2BTeaser from "@/components/landing/B2BTeaser";
import Newsletter from "@/components/landing/Newsletter";
import BlogTeaser from "@/components/landing/BlogTeaser";
import MenTeaser from "@/components/landing/MenTeaser";
import Wardrobe from "@/components/landing/Wardrobe";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import WindowLooks from "@/components/landing/WindowLooks";

export default function Landing() {
  return (
    <main style={{ background: "var(--surface)", color: "var(--on-surface)" }}>
      <Navbar />
      <Hero />
      <WindowLooks variant="b2c" />
      <Marquee />
      <HowItWorks />
      <AppScreens />
      <VideoReels />
      <StyleCheck />
      <ColorTestTeaser />
      <Features />
      <Wardrobe />
      <MiraSeal />
      <Social />
      <SocialProofBar />
      <Testimonials />
      <B2BTeaser />
      <Newsletter />
      <BlogTeaser />
      <MenTeaser />
      <FAQ />
      <Footer />
    </main>
  );
}
